import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { APP_LAUNCH } from './types';
import { appLaunchTrack } from './index';

const thunkAction = actionCreator(APP_LAUNCH);

export const appLaunchThunkAction = () => (dispatch) => {
  dispatch(thunkAction());
  dispatch(appLaunchTrack());
};
